// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ac74855e028ef8e7e37cc0a746663d0fcdb52b2f.chunk.bundle.js";
};